export const GOOD_VIBES_SCOPE_QUERY_KEY = "good-vibes-scope";
export const GOOD_VIBES_PERIOD_QUERY_KEY = "good-vibes-period";
export const GOOD_VIBES_VISIBILITY_QUERY_KEY = "good-vibes-visibility";
export const GOOD_VIBES_SEGMENT_QUERY_KEY = "good-vibes-segment";

export const GOOD_VIBES_FILTER_QUERY_KEYS = [GOOD_VIBES_SCOPE_QUERY_KEY, GOOD_VIBES_PERIOD_QUERY_KEY, GOOD_VIBES_VISIBILITY_QUERY_KEY] as const;
